import { useState } from "react";
import ChatbotButton from "../../../ChatbotButton/ChatbotButton";
import "./ListOfForms.css";

function ListOfForms({ formsData = [] }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [copiedIndex, setCopiedIndex] = useState(null);

  const copyToClipboard = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  const filteredForms = formsData.filter((form) =>
    form.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <ChatbotButton />
      <div className="form-list-container">
        <h1 className="header">
          Find Your Form Below and Copy Its Name to Use in the Chatbot
        </h1>
        <div className="search-bar-container">
          <input
            type="text"
            className="search-bar"
            placeholder="Search for a form..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <ul className="form-list">
          {filteredForms.map((form, index) => (
            <li key={index} className="form-item">
              <span className="form-number">{index + 1}.</span>
              <span className="form-name">{form}</span>
              <button
                className={`copy-button ${
                  copiedIndex === index ? "copied" : ""
                }`}
                onClick={() => copyToClipboard(form, index)}
              >
                {copiedIndex === index ? "Copied" : "Copy"}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default ListOfForms;
